import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FormValidationModule } from '@tablesready/common-ui';
import { RESTORE_PASSWORD_DECLARATIONS } from './components';
import { RestorePasswordRoutingModule } from './restore-password-routing.module';
import { RESTORE_PASSWORD_SERVICES } from './services';
import { IonicModule } from '@ionic/angular';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RestorePasswordRoutingModule,
    FormValidationModule,
    IonicModule,
    AlertsModule,
  ],
  declarations: RESTORE_PASSWORD_DECLARATIONS,
  providers: RESTORE_PASSWORD_SERVICES,
})
export class RestorePasswordModule {
}
